import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useFormContext } from "react-hook-form";
import { getUniqueName, notUndefinedNull } from "../helpers/shared"
import { addValue } from "../helpers/edit"
import { hiddenField, sOption } from "../constants/form"
import { useDispatch } from "react-redux";
import { setLoader } from "../redux/actions/shared";

export  const useAutocompleteDocuments = (field, uniqueName) => {
  const { defaultValuesTier, action } = useSelector(state => state.tier);
  const { areDocumentsFetched, documentsFetched } = useSelector(state => state.base)
  const [areDocumentsProcessed, setAreDocumentsProcessed] = useState(false) 
  const storageDataKey = field?.storage_data_key ? JSON.parse(field.storage_data_key) : null
  const { setValue, getValues } = useFormContext();

  useEffect(() => {
    if (action === 'add') {
      // This effect runs once when the component mounts.
      // It initializes the state `areDocumentsProcessed` to `false`.
      setAreDocumentsProcessed(false)
    }
  }, [])

  const dispatch = useDispatch()
  const values = getValues()
  /* useEffect(() => {
    const safetyDelay = 8000 // Delay required to ensure that the useEffects reseting the values have run already
    if (action === 'edit') {
      // This effect runs whenever `areDocumentsFetched` or `areDocumentsProcessed` changes.
      // It sets a timeout of 8 seconds to ensure that the documents are fetched correctly.
      setTimeout(() => {
        // Add value to the field
        const value = values[uniqueName]
        // Check if the value is valid and not equal to hiddenField or sOption
        let valueExists = value && value !== hiddenField && value !== sOption && notUndefinedNull(value)
        const docType = uniqueName?.split('__')[0]
        console.log(uniqueName + ' here outside')
        // if (uniqueName?.includes('dl__country')) debugger
        // If documents are fetched, storageDataKey is 'documents', and value exists
        if ((areDocumentsFetched === true || true) && storageDataKey?.name === 'documents' && valueExists){
          // If the field datatype is not 'aux', set the value
          console.log(uniqueName + ' here')
          if (field?.datatype !== 'aux'){
            setValue(uniqueName, value)
            console.log(uniqueName)
          } 
            
          // Mark documents as processed
          setAreDocumentsProcessed(true)
          // * This is currently the dispatch responsible of displaying the form
          setTimeout(() => {
            dispatch(setLoader(false))
          }, safetyDelay/4);
        }
      }, safetyDelay)
    }
  }, [areDocumentsFetched, areDocumentsProcessed, values, documentsFetched]) */

  return {}
}

